// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__RCHjb","notFound":"App_notFound__25e2z"};